"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTableOptimizationData = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const tools_1 = require("../tools");
const types_1 = require("../types");
const generateTableOptimizationData = (tableOptimization = {}) => {
    return {
        id: tableOptimization.id || (0, tools_1.IDSource)(),
        title: tableOptimization.title || en_1.faker.word.words(5),
        target_table: tableOptimization.target_table || en_1.faker.word.words(3),
        optimization_type: types_1.OPTIMIZATION_TYPE.PARTITION,
        dimension: tableOptimization.dimension || en_1.faker.word.words(1),
        dimension_type: tableOptimization.dimension_type ||
            en_1.faker.helpers.arrayElement(["TEXT", "TIMESTAMP"]),
        dimension2: tableOptimization.dimension2 || en_1.faker.word.words(1),
        dimension2_type: tableOptimization.dimension2_type ||
            en_1.faker.helpers.arrayElement(["TEXT", "TIMESTAMP"]),
    };
};
exports.generateTableOptimizationData = generateTableOptimizationData;
